import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import { Redirect } from 'react-router'
import { useEventSlug, useSlug } from 'hooks'
import FullPageLoading from 'components/FullPageLoading'
import DrawImageMap from '../../imagemap/DrawImageMap'
import { RootState } from '../../../store'
import { fetchMap, selectMapData } from '../mapSlice'

const S = {
    EscapePagePadding: styled.div`
      margin: -24px;
    `,
}

const MapSpaceForm = () => {
    const dispatch = useDispatch()
    const eventSlug = useEventSlug()
    const mapSlug = useSlug('mapSlug')
    const isFetched = useSelector((state: RootState) => !!state.map.data.id)
    const hasModal = useSelector((state: RootState) => Object.values(state.modals).length > 0)
    const data = useSelector(selectMapData)

    useEffect(() => {
        if (mapSlug) {
            dispatch(fetchMap({ slug: mapSlug, eventSlug }))
        }
    }, [dispatch, mapSlug, eventSlug])

    // Fix weird bugs happen when navigating from 1 map to the next
    if (data?.meta?.slug !== mapSlug) {
        return <FullPageLoading />
    }

    return !isFetched ? null : (
        <S.EscapePagePadding>
            {
                (data?.meta?.image)
                    ? (
                        <DrawImageMap
                            image={data.meta.image}
                            image_height={data.image_height}
                            image_width={data.image_width}
                            ignoreMouseClicks={hasModal}
                        />
                    )
                    : <Redirect to={`/${eventSlug}/map/${mapSlug}/setting`} />
            }
        </S.EscapePagePadding>
    )
}

// @ts-ignore
export default MapSpaceForm
